module.exports = __webpack_public_path__ + "static/profile_phamvanlam-com-co-dien.be33c8b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile_phamvanlam-com-co-dien.jpg
// module id = 687
// module chunks = 106077160987319